module.exports = __webpack_public_path__ + "img/sendSuccessfully-icon.f6425b1e.png";